// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RlfKpKPB4dMxkrgnrnES{align-items:center;margin-top:12px;display:flex}.ZnEZIxxys6UMed_VHGaA{margin:0 4px 0 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusLine": `RlfKpKPB4dMxkrgnrnES`,
	"statusText": `ZnEZIxxys6UMed_VHGaA`
};
export default ___CSS_LOADER_EXPORT___;
